import { Box } from "@mui/material";
import React from "react";

import AboutUs from "../../components/frontend/about/AboutUs";
import { useMetaTags } from "../../hooks/useMetaTags";

const AboutUsPage: React.FC = () => {
  // Set page-specific meta tags
  useMetaTags({
    title: "About Us - R11 Shop",
    description:
      "Learn about R11 Shop's mission, values, and commitment to providing excellent international shipping services from US stores.",
    keywords:
      "about R11 Shop, company information, international shipping, US stores, mission, values",
    canonical: "https://usa2tjik.com/about-us",
  });

  return (
    <Box>
      <AboutUs />
    </Box>
  );
};

export default AboutUsPage;
